<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'; 
import { Icon } from '@iconify/vue';

const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
})

// Define emits for the searchTerm event
const emit = defineEmits(['searchTerm']);

// Reactive state for search query
const searchQuery = ref('');

// Function to emit the search term
const handleSearch = () => {
  if (searchQuery.value === '') return;
  emit('searchTerm', searchQuery.value);
};

// Function to handle the Enter key press
const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    handleSearch();
  }
};

watch(searchQuery, (newValue) => {
  if (newValue === '') {
    emit('searchTerm', '');
  }
});

</script>

<template>
  <div class="flex justify-center">
    <div class="relative flex gap-3 w-full sm:max-w-[450px] lg:w-[550px]">
      <input 
        type="search" 
        v-model="searchQuery" 
        @keydown="handleKeyDown" 
        
        class="flex h-12 rounded-lg w-full text-sm ring-offset-gray-600 placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-900 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 py-2 px-3 border-2 border-gray-900 w-full bg-primary text-gray-800 focus:border-none active:border-none sono" 
        placeholder="Search for token"
      />
      <button @click="handleSearch" class="absolute top-0 right-0 w-12 flex items-center justify-center text-black h-full">
       <span v-if="!loading"><Icon icon="mingcute:search-3-line" class="text-gray-800"/></span>
       <Icon v-else icon="svg-spinners:90-ring" class="animate-spin w-[58px] text-lg" />
      </button>
    </div>
  </div>
</template>
<style scoped>
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
    display: none;
}
input[type="search"]::-ms-clear {
    display: none;
    height: 0;
    width : 0;
}

input[type="search"]::-ms-reveal {
    display: none;
    height: 0;
    width : 0;
}
</style>